const sortCartEndpoints = ({localCartState, availableEndpoints}) => {
    const invalidEndpoints = [];
    const validEndpoints = [];
    localCartState.map(e => {
        const availableEndpoint = availableEndpoints.find(el => el.id === e.endpointId);
        if (!availableEndpoint) {
            invalidEndpoints.push({
                ...e,
                available: false,
                maxQuantity: 0
            });
        } else {
            if (availableEndpoint.quantity < e.quantity) {
                invalidEndpoints.push({
                    ...e,
                    available: false,
                    quantity: e.quantity - availableEndpoint.quantity,
                    maxQuantity: 0
                });
                validEndpoints.push({
                    ...e,
                    available: true,
                    quantity: availableEndpoint.quantity,
                    maxQuantity: availableEndpoint.quantity
                });
            } else {
                validEndpoints.push({
                    ...e,
                    maxQuantity: availableEndpoint.quantity,
                    available: true
                });
            }
            
        }
    });
    const sortedEndpoints = [...validEndpoints, ...invalidEndpoints];
    return {
        invalidEndpoints,
        validEndpoints,
        sortedEndpoints,
        hasInvalidEndpoints: !!invalidEndpoints.length
    }
};

export default sortCartEndpoints;